import React, { useState } from 'react';
import styles from '../app.module.css';

const TagsSection = ({ tags, handleTagChange, handleTagExternalDocsChange, removeTag, addTag }) => {
  const [tempTag, setTempTag] = useState(null);
  const [tempTagIndex, setTempTagIndex] = useState(null);
  const [errors, setErrors] = useState({});

  const validateTag = (tag) => {
    const urlPattern = /^(https?:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
    const newErrors = {};

    if (!tag?.name) {
      newErrors.name = 'Name is required.';
    }
    const isDuplicate = tags.some((existingTag, index) => {
      return existingTag.name === tag.name && tempTagIndex !== index;
    });

    if (isDuplicate) {
      newErrors.name = 'Tag name must be unique.';
    }

    if (tag?.externalDocs?.url && !urlPattern.test(tag.externalDocs.url)) {
      newErrors.externalDocsUrl = 'Invalid URL format.';
    }

    return newErrors;
  };

  const handleSaveTag = () => {
    const validationErrors = validateTag(tempTag);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    if (tempTagIndex === tags.length) {
      addTag(tempTag);
    } else {
      handleTagChange(tempTagIndex, 'name', tempTag.name);
      handleTagChange(tempTagIndex, 'description', tempTag.description);
      handleTagExternalDocsChange(tempTagIndex, 'description', tempTag.externalDocs.description);
      handleTagExternalDocsChange(tempTagIndex, 'url', tempTag.externalDocs.url);
    }
    setTempTag(null);
    setTempTagIndex(null);
    setErrors({});
  };

  const handleCancel = () => {
    setTempTag(null);
    setTempTagIndex(null);
    setErrors({});
  };

  const handleAddTagClick = () => {
    setTempTag({ name: '', description: '', externalDocs: { description: '', url: '' } });
    setTempTagIndex(tags.length);
  };

  const handleEditTagClick = (index) => {
    setTempTag({ ...tags[index] });
    setTempTagIndex(index);
  };

  return (
    <div>
      <h3 className={styles.centeredHeading}>Tags</h3>

      {tags.map((tag, index) => (
        <div key={index} className={styles.mainContainer}>
          <p><strong>Name:</strong> {tag.name}</p>
          <p><strong>Description:</strong> {tag.description || 'N/A'}</p>
          {tag.externalDocs && (
            <>
              <p><strong>External Docs Description:</strong> {tag.externalDocs.description || 'N/A'}</p>
              <p><strong>External Docs URL:</strong> {tag.externalDocs.url || 'N/A'}</p>
            </>
          )}
          <div className={styles.actionButtonsContainer}>
            <button className={styles.editButton} onClick={() => handleEditTagClick(index)}>Edit</button>
            <button className={styles.deleteButton} onClick={() => removeTag(index)}>Delete</button>
          </div>
        </div>
      ))}

      {tempTag !== null && (
        <div className={styles.mainContainer}>
          <div>
            <label>
              Name <span className={styles.requiredField}>*</span>
            </label>
            <input
              type="text"
              value={tempTag.name}
              onChange={(e) => setTempTag({ ...tempTag, name: e.target.value })}
              placeholder="Enter tag name"
              className={styles.textBox}
            />
            {errors.name && <p className={styles.inlineAlerts}>{errors.name}</p>}
          </div>
          <div>
            <label>Description:</label>
            <textarea
              value={tempTag.description}
              onChange={(e) => setTempTag({ ...tempTag, description: e.target.value })}
              placeholder="Enter description"
              className={styles.textBox}
            />
          </div>
          <div>
            <label>External Docs Description:</label>
            <input
              type="text"
              value={tempTag.externalDocs.description}
              onChange={(e) =>
                setTempTag({
                  ...tempTag,
                  externalDocs: { ...tempTag.externalDocs, description: e.target.value },
                })
              }
              placeholder="Enter external docs description"
              className={styles.textBox}
            />
          </div>
          <div>
            <label>External Docs URL:</label>
            <input
              type="text"
              value={tempTag.externalDocs.url}
              onChange={(e) =>
                setTempTag({
                  ...tempTag,
                  externalDocs: { ...tempTag.externalDocs, url: e.target.value },
                })
              }
              placeholder="Enter external docs URL"
              className={styles.textBox}
            />
            {errors.externalDocsUrl && <p className={styles.inlineAlerts}>{errors.externalDocsUrl}</p>}
          </div>

          <div className={styles.sNcButtonContainer}>
            <button className={styles.saveButton} onClick={handleSaveTag}>Save</button>
            <button className={styles.cancelButton} onClick={handleCancel}>Cancel</button>
          </div>
        </div>
      )}

      {tempTag === null && (
        <button className={styles.addNewButton} onClick={handleAddTagClick}>
          + Add Tag
        </button>
      )}
    </div>
  );
};

export default TagsSection;
